import {tx, ptx, usePageText} from '../../lib/page-text';
import { useState } from "react";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { api } from "../../lib/api-client";
export function BoardPages({
  streamId,
  version,
  disabled,
  onChange,
}: {
  streamId: string;
  version: number;
  disabled: boolean;
  onChange: () => Promise<unknown>;
}) {
  usePageText();
  const qc = useQueryClient(),
    [busy, setBusy] = useState(false),
    [error, setError] = useState(""),
    [title, setTitle] = useState("");
  const q = useQuery({
    queryKey: ["board-pages", streamId],
    queryFn: async () =>
      (
        await api.get<{
          activeId: string;
          pages: { id: string; title: string }[];
        }>(`/me/streams/${streamId}/board/pages`)
      ).data,
    refetchInterval: 5000,
  });
  async function switchPage(pageId?: string) {
    setBusy(true);
    setError("");
    try {
      const { data } = await api.post(`/me/streams/${streamId}/board/pages`, {
        version,
        ...(pageId
          ? { pageId }
          : {
              title: title.trim() || `Page ${(q.data?.pages.length ?? 0) + 1}`,
            }),
      });
      qc.setQueryData(["board-pages", streamId], data);
      setTitle("");
      await onChange();
    } catch (e: any) {
      setError(
        e?.response?.data?.message ?? "Could not switch page. Try again.",
      );
    } finally {
      setBusy(false);
    }
  }
  return (
    <div className="board-pages">
      <label>{ptx("Board page{v0}{v1}", {v0: (" "), v1: (<select
          className="input"
          aria-label={tx("Board page")}
          value={q.data?.activeId ?? "main"}
          disabled={disabled || busy || !q.data}
          onChange={(e) => void switchPage(e.target.value)}
        >
          {q.data?.pages.map((p) => (
            <option key={p.id} value={p.id}>
              {p.title}
            </option>
          ))}
        </select>)})}</label>
      <details>
        <summary>{tx("Add page")}</summary>
        <div className="program-row">
          <input
            className="input"
            aria-label={tx("New page title")}
            value={title}
            maxLength={100}
            onChange={(e) => setTitle(e.target.value)}
            placeholder={tx("Page title")}
          />
          <button
            className="btn outline sm"
            disabled={disabled || busy || (q.data?.pages.length ?? 0) >= 50}
            onClick={() => void switchPage()}
          >{tx("Create page")}</button>
        </div>
      </details>
      {q.isError && (
        <button className="btn ghost sm" onClick={() => void q.refetch()}>{tx("Retry pages")}</button>
      )}
      {error && <span role="alert">{error}</span>}
    </div>
  );
}
